// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component-spinner>.loading[data-v-9651606c]{animation:sk-bouncedelay-9651606c 1.4s ease-in-out infinite both;will-change:transform}.component-spinner>.component-spinner-ball-1[data-v-9651606c]{animation-delay:-.32s}.component-spinner>.component-spinner-ball-2[data-v-9651606c]{animation-delay:-.16s}@keyframes sk-bouncedelay-9651606c{0%{transform:scale(0)}40%{transform:scale(1)}80%,to{transform:scale(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
